const cn = {
    nav: { //头部导航
        navList: [{
                name: "首页",
                url: "/",
            },
            {
                name: "关于我们",
                url: "/about",
            },
            {
                name: "主营业务",
                url: "/gpc",
            },
            {
                name: "业务领域",
                url: "/besinessScope/bulkTrade",
            },
            {
                name: "新闻中心",
                url: "/news",
            },
            {
                name: "社会责任",
                url: "/socialResponsibility",
            },
            {
                name: "人才发展",
                url: "/talentDevelopment",
            },
            {
                name: "监督举报",
                url: "/supervisionAndReporting",
            },
        ],
        Logo: require("../../assets/img/base/logo20.png"),
        Logo_white: require("../../assets/img/base/logo20_white.png"),
        Language: {
            cn: "中文",
            en: "ENGLISH",
            ru: "РУССКИЙ"
        },
    },
    foot: { //脚注和全屏菜單
        footNav: [{
                title: {
                    name: "关于我们",
                    url: "/about",
                },
                list: [{
                        name: "公司简介",
                        url: "/about",
                        param: "company"
                    },
                    {
                        name: "发展历程",
                        url: "/about",
                        param: "history"
                    },
                    {
                        name: "企业文化",
                        url: "/about",
                        param: "culture"
                    },
                    {
                        name: "公司荣誉",
                        url: "/about",
                        param: "honor"
                    },
                    {
                        name: "团队风采",
                        url: "/about",
                        param: "teamStyle"
                    },
                ]
            },
            {
                title: {
                    name: "主营业务",
                    url: "/gpc",
                },
                list: [{
                        name: "石油焦",
                        url: "/gpc",
                        param: ""
                    },
                    {
                        name: "煅后焦",
                        url: "/cpc",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "业务领域",
                    url: "/besinessScope/bulkTrade",
                },
                list: [{
                        name: "大宗贸易",
                        url: "/besinessScope/bulkTrade",
                        param: ""
                    },
                    {
                        name: "综合物流",
                        url: "/besinessScope/integratedLogistics",
                        param: ""
                    },
                    {
                        name: "生产制造",
                        url: "/besinessScope/productionManufacturing",
                        param: ""
                    },
                    {
                        name: "产融协同",
                        url: "/besinessScope/industryFinanceCollaboration",
                        param: ""
                    },
                    {
                        name: "劳务输出",
                        url: "/besinessScope/exportOfServices",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "新闻中心",
                    url: "/news",
                },
                list: [{
                        name: "最新资讯",
                        url: "/news",
                        param: "tab1"
                    },
                    {
                        name: "媒体报道",
                        url: "/news",
                        param: "tab2"
                    },
                    {
                        name: "企业宣传",
                        url: "/news",
                        param: "tab3"
                    },
                ]
            },
            {
                title: {
                    name: "社会责任",
                    url: "/socialResponsibility",
                },
                list: [{
                        name: "环境保护",
                        url: "/socialResponsibility",
                        param: "environmental"
                    },
                    {
                        name: "科技创新",
                        url: "/socialResponsibility",
                        param: "science"
                    },
                    {
                        name: "社会公益",
                        url: "/socialResponsibility",
                        param: "socialGood"
                    },
                ]
            },
            {
                title: {
                    name: "人才发展",
                    url: "/talentDevelopment",
                },
                list: [{
                        name: "人才发展",
                        url: "/talentDevelopment",
                        param: ""
                    },
                    {
                        name: "人才招聘",
                        url: "/talentRecruitment/1",
                        param: ""
                    },
                ]
            },
            {
                title: {
                    name: "监督举报",
                    url: "/supervisionAndReporting",
                },
                list: [{
                    name: "监督举报",
                    url: "/supervisionAndReporting",
                    param: ""
                }]
            },
        ],
        Address: "地址：北京市朝阳区安慧里四区15号中国五矿大厦13层",
        Phone: "电话：+86 10-84831159 总机  &nbsp; &nbsp;  +86 10-84833454 内贸  &nbsp;&nbsp;  +86 10-84832433 外贸",
        tel:"业务合作：+86 17813617961 &nbsp;&nbsp; 总裁办公室：+86 17813617885",
        Email: "邮箱：Gaoxin@gaoxincarbon.com",
        RecruitTel: "招聘联系电话：17813617991",
        RecruitEmail: "简历投递邮箱：hr@dqc.group",
        contactUs: "关注我们",
        copyright: "大庆高新国际工贸有限公司",
    },
    sidebar: {
        Message: "在线留言",
    },
    dialogContact: { //联系我们弹框
        TelephoneCounseling: "电话咨询",
        DomesticTradePhone: "内贸",
        ForeignTradePhone: "外贸",
        HRphone: "总机"
    },
    messageBoard: { //在线留言弹框
        OnlineMessage: "在线留言",
        BusinessType: "业务类型",
        SelectBusinessType: "选择业务类型",
        name: "姓名",
        phone: "电话",
        email: "邮箱",
        message: "留言",
        SubmitMessage: "提交",
        rules: {
            SelectBusinessType: "请选择业务类型",
            EnterName: "请输入姓名",
            NameLength: "长度在 2 到 20 个字符",
            ContactNumber: "请输入联系电话",
            PhoneLength: "请输入正确手机号码",
            EmailAddress: "请输入邮箱地址",
            CorrectEmailAddress: "请输入正确的邮箱地址",
            messageContent: "请输入留言内容",
        },
        SubmitSuccessfully: "提交成功"
    },
    home: {
        banner: {
            businessScope: [{
                    title: "大宗贸易",
                    icon: require("../../assets/img/home/trade.png"),
                    des: "集团核心业务模块",
                    businessSlide: `<li>能源</li>
                        <li>工业原料</li>
                        <li>金属/矿产</li>
                        <li>石化产品</li>
                        <li>农产品</li>
                        <li>机电仪</li>
                        <li>锂电池及其上下游</li>`,
                    pic: require("../../assets/img/base/trade.png"),
                    src: '/besinessScope/bulkTrade'
                },
                {
                    title: "综合物流",
                    icon: require("../../assets/img/home/logistics.png"),
                    des: "全球物流网络布局",
                    businessSlide: `<li>仓储物流</li>
                        <li>跨境物流</li>
                        <li>网络货运</li>`,
                    pic: require("../../assets/img/base/logistics.png"),
                    src: '/besinessScope/integratedLogistics'
                },
                {
                    title: "生产制造",
                    icon: require("../../assets/img/home/manufacturing.png"),
                    des: "产业链升级",
                    businessSlide: `<li>抚顺隆腾工厂</li>
                        <li>铝制品加工厂</li>`,
                    pic: require("../../assets/img/base/manufacturing.png"),
                    src: '/besinessScope/productionManufacturing'
                },
                {
                    title: "产融协同",
                    icon: require("../../assets/img/home/finance.png"),
                    des: "资产价值开发",
                    businessSlide: `<li>全球布局</li>
                        <li>代采与代销</li>
                        <li>保障与保理</li>
                        <li>产业投资</li>`,
                    pic: require("../../assets/img/base/finance.png"),
                    src: '/besinessScope/industryFinanceCollaboration'
                },
                {
                    title: "劳务输出",
                    icon: require("../../assets/img/home/services.png"),
                    des: "人力资源一站式服务",
                    businessSlide: `<li>企业优势</li>`,
                    pic: require("../../assets/img/base/services.png"),
                    src: '/besinessScope/exportOfServices'
                }
            ],
            year20: "20周年专题报道"
        },
        company: {
            headlineTitle: "企业介绍",
            headlineP: "COMPANY INTRODUCTION",
            map: {
                Canada: "加拿大",
                USA: "美国",
                Colombia: "哥伦比亚",
                Brazil: "巴西",
                Chile: "智利",
                Argentina: "阿根廷",
                Germany: "德国",
                Romania: "罗马尼亚",
                Turkey: "土耳其",
                Egypt: "埃及",
                Saudi_Arabia: "沙特阿拉伯",
                Kazakhstan: "哈萨克斯坦",
                Turkmenistan: "土库曼斯坦",
                Dubai: "迪拜",
                India: "印度",
                Russia: "俄罗斯",
                China: "中国",
                Taiwan: "中国·台湾省",
                Malaysia: "马来西亚",
                Korea: "韩国",
                Japan: "日本",
                Philippines: "菲律宾",
                Indonesia: "印尼 ",
                Sydney: "悉尼"
            },
            companyName: "大庆高新国际工贸集团",
            nameTag: "DQ CARBON GROUP",
            companyNumber: [{
                    detail: "企业成立"
                },
                {
                    detail: "国内外分支机构"
                },
                {
                    detail: "业务遍布国家 "
                },
                {
                    detail: "企业员工"
                },
            ],
            more: "更多"
        },
        businessLayout: {
            headlineTitle: "业务布局",
            headlineP: "BUSINESS LAYOUT",
        },
        product: {
            headlineTitle: "主营产品",
            headlineP: "MAIN PRODUCT",
            res: [{
                    title: "石油焦",
                    titleEn: "GPC",
                    des: "公司主要与中石化、中石油、中海油所属炼厂及山东、东北、西北、河南、河北、江苏等地方炼油厂、国外大型石油化工企业及贸易商合作，同时与国内外大型铝厂、钢厂、金属硅厂、玻璃生产企业等建立长期合作的战略伙伴关系。",
                    pic: require("../../assets/img/home/gpc.png"),
                    src: "/gpc"
                },
                {
                    title: "煅后焦",
                    titleEn: "CPC",
                    des: "我公司于2018年在辽宁葫芦岛建立煅烧焦加工厂委托加工形式可达到20万吨石墨电极用低硫煅烧焦每月6000吨公司聘请煅烧焦加工行业专家拥有专业的技术团队，主要面向锦西大庆抚顺石油焦进行煅烧和筛分业务可按照客户需求进行定制加工、来料加工服务品质保障。在产品质量价格、物流仓储产品检验、快速结算等方面，我们可以为客户优化采购方案,保证产品质量合格、价格合理、配送及时。为广大客户降低成本，提供满意的服务,创造更大的价值。",
                    pic: require("../../assets/img/home/cpc.png"),
                    src: "/cpc"
                },
            ],
            button: "了解更多"
        },
        news: {
            headlineTitle: "新闻资讯",
            headlineP: "NEWS INFORMATION",
        },
        partner: {
            headlineTitle: "合作企业",
            headlineP: "COOPERATIVE ENTERPRISE",

        }
    },
    about: {
        banner: {
            bannerTitle: "关于我们",
            bannerP: "立志资源·创造价值",
        },
        company: {
            headlineTitle: "集团介绍",
            headlineP: "Group Profile",
        },
        messageFromChairman: {
            title: "董事长寄语",
        },
        history: {
            headlineTitle: "发展历程",
            headlineP: "DEVELOPMENT HISTORY",
        },
        culture: {
            headlineTitle: "企业文化",
            headlineP: "CORPORATE CULTURE",
            section: [{
                    title: "发展观",
                    des: `<p>依法治企、以德治企</p><p>勤俭办企、廉洁爱企</p><p>人才强企、科技兴企</p>`
                },
                {
                    title: "市场观",
                    des: `<p>全力做好品控、打造行业卓越品牌</p><p>客户的成功就是我们的成功</p><p>客户的价值也是我们的价值</p>`
                },
                {
                    title: "人才观",
                    des: `<p>崇尚知识、以人为本</p><p>尊重人才、关心人才</p><p>培养人才、重用人才</p>`
                },
                {
                    title: "效率观",
                    des: `<p>快人一步、领先一路</p>`
                },
                {
                    title: "奋斗观",
                    des: `<p>伟大事业是拼出来、</p><p>干出来、奋斗出来的</p>`
                },
                {
                    title: "成长观",
                    des: `<p>律己足以服人、量宽足以待人</p><p>轻财足以聚人、身先是以率人</p>`
                }
            ]
        },
        honor: {
            headlineTitle: "企业荣誉",
            headlineP: "Honors & Awards",
        },
        teamStyle: {
            headlineTitle: "团队风采",
            headlineP: "Team Highlights",
        }
    },
    mainBusiness: {
        gpc: {
            header: {
                typeTitle: "主营产品",
                title: "石油焦",
                enTitle: "GPC",
                des: `公司主要与中石化、中石油、中海油所属炼厂及山东、东北、西北、河南、河北、江苏等地方炼油厂、
                国外大型石油化工企业及贸易商合作，同时与国内外大型铝厂、钢厂、金属硅厂、玻璃生产企业等建立长期合作的战略伙伴关系。`,
            },
            parameters: {
                title: "典型值",
                tabs: {
                    internal: "国内",
                    foreign: "国外",
                },
                parameterRow: [{
                        pic: require("../../assets/img/mainBusiness/sy.png"),
                        lists: [{
                                value: "＜0.5",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜10",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜0.35",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜10",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜100",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜200",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/sh.png"),
                        lists: [{
                                value: "＜2.2",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜0.5",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜10",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜150",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜100",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜200",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/nooc.png"),
                        lists: [{
                                value: "＜0.5",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜10",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜0",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜250",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜200",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/dl.png"),
                        lists: [{
                                value: "＜4.5",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜10",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜350",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜300",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜200",
                                name: "硅含量(%)"
                            },
                        ]
                    }
                ],
                foreignParameterRow: [{
                        title: "中东",
                        pic: require("../../assets/img/mainBusiness/zhongdong.png"),
                        lists: [{
                                value: "＜3.3",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜10",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜200",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜200",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜100",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        title: "印尼",
                        pic: require("../../assets/img/mainBusiness/yingni.png"),
                        lists: [{
                                value: "＜0.50",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜14.5",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜10",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜120",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜150",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        title: "美国",
                        pic: require("../../assets/img/mainBusiness/meiguo.png"),
                        lists: [{
                                value: "＜4.5",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜12",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜450",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜150",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜180",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        title: "欧洲",
                        pic: require("../../assets/img/mainBusiness/ouzhou.png"),
                        lists: [{
                                value: "＜1.5",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜10",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜200",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜150",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜150",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        title: "南美",
                        pic: require("../../assets/img/mainBusiness/nanmei.png"),
                        lists: [{
                                value: "＜0.7",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜10",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜0.3",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜180",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜80",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜80",
                                name: "硅含量(%)"
                            },
                        ]
                    },
                    {
                        title: "独联体",
                        pic: require("../../assets/img/mainBusiness/dulianti.png"),
                        lists: [{
                                value: "＜1.8",
                                name: "硫分(%)"
                            },
                            {
                                value: "＜10",
                                name: "挥发分(%)"
                            },
                            {
                                value: "＜0.2",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜200",
                                name: "钒含量(%)"
                            },
                            {
                                value: "＜150",
                                name: "铁含量(%)"
                            },
                            {
                                value: "＜150",
                                name: "硅含量(%)"
                            },
                        ]
                    }
                ],
            },
            petroleumBases: {
                headline2: {
                    title: "国内石油焦四大基地",
                    enTitle: "Four major domestic petroleum coke bases"
                },
                lists: [{
                        pic: require("../../assets/img/mainBusiness/db.png"),
                        title: "东北基地",
                        des: "充分利用东北资源优势，优化夯实仓储混配物流基地建设和布局方案，开展差异化经营。"
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/hd.png"),
                        title: "华东基地",
                        des: "基地人员实行专业和属地化双重管理模式，提升服务，提高专业化管理水平。"
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/hn.png"),
                        title: "华南基地",
                        des: "立足华南市场和产业布局优势，促进石油焦产品向下游产业链延伸，提高综合业务运营能力。"
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/xb.png"),
                        title: "西北基地",
                        des: "完善采购、销售和物流管理一体化的联动机制，提升对市场主动配合和快速响应能力。"
                    }
                ]
            },
            storageBase: {
                headline2: {
                    title: "仓储基地",
                    enTitle: "Storage base"
                },
                des: `公司主要与中石化、中石油、中海油所属炼厂及山东、东北、西北、河南、河北、江苏等地方炼油厂、国外大型石油化工企业及贸易商合作，
                同时与国内外大型铝厂、钢厂、金属硅厂、玻璃生产企业等建立长期合作的战略伙伴关系。`
            },
            recommend: {
                headline2: {
                    title: "相关推荐",
                    enTitle: "Relevant recommendation"
                }
            }
        },
        cpc: {
            header: {
                typeTitle: "主营产品",
                title: "煅后焦",
                enTitle: "CPC",
                des: `我公司于2018年在辽宁葫芦岛建立煅烧焦加工厂委托加工形式可达到20万吨石墨电极用低硫煅烧焦每月6000吨公司聘请煅烧焦加工行业专家拥有专业的技术团队，
                主要面向锦西大庆抚顺石油焦进行煅烧和筛分业务可按照客户需求进行定制加工、来料加工服务品质保障。在产品质量价格、物流仓储产品检验、快速结算等方面，我们可以为客户优化采购方案,
                保证产品质量合格、价格合理、配送及时。为广大客户降低成本，提供满意的服务,创造更大的价值。`,
            },
            parameters: {
                titleM: "中硫焦",
                parameterM: [{
                        pic: require("../../assets/img/mainBusiness/zbh.png"),
                        name: "指标货",
                        lists: [{
                                value: "≤3",
                                name: "硫分(%)"
                            },
                            {
                                value: "≤1.5",
                                name: "挥发分(%)"
                            },
                            {
                                value: "≤500",
                                name: "钒含量(%)"
                            },
                            {
                                value: "≥2.05",
                                name: "真密度(%)"
                            },
                            {
                                value: "≤0.5",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜500",
                                name: "比电阻(%)"
                            },
                        ]
                    },
                    {
                        pic: require("../../assets/img/mainBusiness/puhuo.png"),
                        name: "普货",
                        lists: [{
                                value: "≤3.5",
                                name: "硫分(%)"
                            },
                            {
                                value: "≤1.5",
                                name: "挥发分(%)"
                            },
                            {
                                value: "≥600",
                                name: "钒含量(%)"
                            },
                            {
                                value: "≥2.05",
                                name: "真密度(%)"
                            },
                            {
                                value: "≤0.5",
                                name: "灰分(%)"
                            },
                            {
                                value: "＜550",
                                name: "比电阻(%)"
                            },
                        ]
                    },
                ],
                titleL: "低硫焦",
                parameterL: [{
                    pic: require("../../assets/img/mainBusiness/fsgc.png"),
                    name: "抚顺工厂",
                    lists: [{
                            value: "≤0.5",
                            name: "硫分(%)"
                        },
                        {
                            value: "≤0.5",
                            name: "挥发分(%)"
                        },
                        {
                            value: "0.5",
                            name: "水分(%)"
                        },
                        {
                            value: "≥2.08",
                            name: "真密度(%)"
                        },
                        {
                            value: "≤0.5",
                            name: "灰分(%)"
                        },
                        {
                            value: "350~450",
                            name: "比电阻(%)"
                        },
                    ],
                    url: '/besinessScope/productionManufacturing'
                }, ],
            },
            recommend: {
                headline2: {
                    title: "相关推荐",
                    enTitle: "Relevant recommendation"
                }
            }
        }
    },
    bulkTrade: {
        banner: {
            bannerTitle: "大宗贸易",
            bannerP: "Bulk Trade",
        },
        headlineTitle: "大宗贸易",
        headlineP: "BULK TRADE",
        mainBusiness: '主营',
    },
    bulkTradeDetail: {
        home: "首页",
        lists: "大宗贸易",
        share: "分享至",
        copyAddress: '复制地址',
        productIntroduction: "产品简介",
        factoryIntroduction: '作业现场',
        relevantRecommendation: '相关推荐'
    },
    integratedLogistics: {
        banner: {
            bannerTitle: "综合物流",
            bannerP: "Integrated logistics",
        },
        logisticsService: {
            headlineTitle: "物流服务",
            headlineP: "LOGISTICS SERVICE",
            lists: [{
                    title: "公路运输",
                    des: `基于长年的运营积累，公司整合了8000+合作车辆资源，承运范围盖大宗散货、工程车辆、零配件、危险品等货物。
                    以丰富的运力管理经验为基础，以优质的客户服务体验为目标，向客户提供国内公路运输服务。`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service1.png")
                },
                {
                    title: "铁路运输",
                    des: `在铁路服务方面拥有一支高素质、操作经验丰富的专业团队，擅长组织大宗货物、工程设备、大件货物运输，能够高效处理各类复杂的运输需求，
                    业务覆盖国内各地区间、中亚五国等国家和地区，为客户的货物发运保驾护航。`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service2.png")
                },
                {
                    title: "海运",
                    des: "依托与船公司及港口的长期稳定合作，根据客户要求，制定完备的运输方案，提供租船订舱、集港、监装、货物跟踪等全面完善的一站式散货船运服务。",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service3.png")
                },
                {
                    title: "多式联运",
                    des: "聚焦客户需求，整合公路、铁路、水路等各类资源，为客户提供门到门的多式联运解决方案，发挥各种运输方式的优势和组合效率，为客户精简运输环节，节省货运成本，提高经济效益。",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service4.png")
                },
                {
                    title: "跨境物流",
                    des: "响应国家“一带一路”倡议号召，加速业务国际化布局，面对客户不同需求，提供国际运输、境外清关、跨境人民币结算一体化业务，打通跨国供应链痛点，可承接大规模长协业务。",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service5.png")
                },
                {
                    title: "液化气罐车运输",
                    des: `公司拥有专业的运输管理团队，熟悉LPG物理化学特性及危险品安全运输标准，为客户提供量身定制的LPG运输解决方案，车辆均配备GPS卫星定位系统与紧急制动系统，实现全程可视化监控与快速响应，全方位保障运输安全。`,
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/service6.png")
                },
            ]
        },
        loremIpsumDolorSit: {
            headlineTitle: "仓储加工",
            headlineP: "LOREM IPSUM DOLOR SIT",
            des: "公司在盘锦、日照、潍坊、连云港、防城、钦州等重要国内港口、韩国建立了战略进出口基地;在新疆、青海、甘肃、宁夏、山东、河南、重庆、辽宁等国内省市建立货物周转库及加工基地。",
            map: require('../../assets/img/businessScope/integratedLogistics/map.png'),
            lists: [{
                    title: "物流加工",
                    des: "根据货物性质及客户需求，可提供筛分、掺配、灌包等增值服务，满足客户的多样化需求。",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/wljg.png"),
                    icon: require("../../assets/img/businessScope/integratedLogistics/wljg_icon.png"),
                },
                {
                    title: "采购代理服务",
                    des: "构建了大宗货物及石油设备、工程机械、车辆配件、电子产品及矿石类等商品的展销采购平台，结合门到门运输服务，为客户提供为客户提供全方位的采购代理服务。",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/cgdl.png"),
                    icon: require("../../assets/img/businessScope/integratedLogistics/cgdl_icon.png"),
                },
            ]
        },
        networkFreight: {
            headlineTitle: "网络货运",
            headlineP: "NETWORK FREIGHT",
            picUrl: require("../../assets/img/businessScope/integratedLogistics/wlhy.jpg"),
            lists: [{
                    title: "好运达平台",
                    des: "自建集团物流服务交易平台，过程管理、电子台账、支持系统对接联调、提供一站式运输服务。",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network1.png"),
                },
                {
                    title: "企业赋能",
                    des: "拥有自有研发团队，协助企业推动数字化转型，为企业信息化降本增效。",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network2.png"),
                },
                {
                    title: "增值服务",
                    des: "以陆运大宗散货运输业务为核心，打造货主、司机、平台、保险、金融、车后服务的生态产业链。",
                    icon: require("../../assets/img/businessScope/integratedLogistics/network3.png"),
                },

            ]
        },
        projectCase: {
            headlineTitle: "项目案例",
            headlineP: "PROJECT CASE",
            lists: [{
                    title: "工程车辆 跨国公路项目",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case1.png"),
                },
                {
                    title: "超限货物 公路运输",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case2.png"),
                },
                {
                    title: "铝制品海运 集装箱拼箱",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case3.png"),
                },
                {
                    title: "中欧班列 铁路运输",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case4.png"),
                },
                {
                    title: "车辆及配件 集装箱项目",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case5.png"),
                },
                {
                    title: "大宗商品 海运项目",
                    picUrl: require("../../assets/img/businessScope/integratedLogistics/case6.png"),
                },
            ]
        }
    },
    productionManufacturing: {
        banner: {
            bannerTitle: "生产制造",
            bannerP: "Production Manufacturing",
        },
        table: {
            fushun: "抚顺隆腾工厂",
            lv: "铝制品加工厂"
        },
        FS: {
            factory: {
                headlineTitle: "抚顺隆腾工厂",
                headlineP: "FUSHUN LONGTENG FACTORY",
                des: "大庆高新国际工贸集团于2022年4月成立全资子公司--抚顺隆腾新材料有限公司，主营新材料与新能源技术产品的研发、生产、销售，是辽宁省重点招商引资企业和抚顺市新能源行业龙头骨干企业。",
                factoryBox: {
                    title: "FUSHUN LONGTENG FACTORY",
                    smallTitle: "抚顺隆腾工厂",
                    des: "项目坐落于抚顺高新技术产业开发区，占地面积约192亩，设计总投资17.1亿元，主要生产锂电池人造石墨负极材料、碳素等新材料、新能源领域产品及相关技术研发和销售，产品已畅销国内各地及出口多个国家和地区。",
                    link: '抚顺隆腾官网链接：https://www.fsltxcl.cn/'
                }
            },
            manufacturingStrength: {
                headlineTitle: "制造实力",
                headlineP: "MANUFACTURING STRENGTH",
                lists: [{
                        title: "负极车间",
                        des: `负极车间生产线集成了负极材料的破碎、烘干、粉碎等多道工序，通过高度自动化的设备和流程，实现了从原材料到成品的高效转化。`,
                        des2: `年产能:烘干生产线15万吨、粉碎生产线10万吨。`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl1.png")
                    },
                    {
                        title: "煅烧车间",
                        des: `煅烧车间主要由原料预处理装置、煅烧炉装置、冷却水装置、脱硫塔装置、余热锅炉装置等装置组成。`,
                        des2: `年产能:煅烧生产线6万吨。`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl2.png")
                    },
                    {
                        title: "造粒车间",
                        des: `造粒车间是专门进行新能源物料造粒的生产区域，其产品广泛应用于新能源行业多个领域。`,
                        des2: `规划、建设、投产年产8万吨造粒及预碳化生产线。`,
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/zzsl3.png")
                    },
                ]
            },
            mainProduct: {
                headlineTitle: "主营产品",
                headlineP: "MAIN PRODUCT",
                lists: [{
                        title: "低硫煅后焦",
                        des: "选用优质低硫石油焦生产，经过破碎和煅烧炉处理，可作为锂电负极和优质石墨电极原料。产品应用于锂电负极行业和高功率、超高功率石墨电极炭素行业，并可根据客户需要定制化产品。 ",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main1.png")
                    },
                    {
                        title: "锂电负极粉碎前驱体",
                        des: "新能源锂电负极粉碎前驱体，以锂电负极行业优质石油焦、针状焦或煅后焦为原料生产，并可根据客户需要定制化产品。 ",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main2.png")
                    },
                    {
                        title: "煅后焦人造石墨负极材料",
                        des: "选用优质原料，经过多道工序处理。产品膨胀小、加工性能好、容量高、综合性价比突出，适用于储能和容量型3C类电池等。 ",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main3.png")
                    },
                    {
                        title: "人造石墨负极材料",
                        des: "选用优质原材料，经过造粒、预碳化等多道热处理工艺精细处理。优异的高温循环性能和倍率、良好的容量和加工性能，适用于电动车等动力类负极。 ",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main4.png")
                    },
                    {
                        title: "针状焦人造石墨负极材料",
                        des: "选用优质针状焦为原料，经过粉碎、造粒、石墨化和后工序处理，产品具有良好的容量、循环性能和倍率性能，适用于负极中高端各领域使用。 ",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/main5.png")
                    },
                ]
            },
            qualityAssurance: {
                headlineTitle: "品质保障",
                headlineP: "QUALITY ASSURANCE",
                lists: [{
                        title: "百特激光粒度仪",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/baitejiguan.jpg")
                    },
                    {
                        title: "粉末电阻率测定仪",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/fengmodianzu.jpg")
                    },
                    {
                        title: "光谱仪",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/guangpuyi.jpg")
                    },
                    {
                        title: "马尔文激光粒度仪",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/jiguangliduyi.jpg")
                    },
                    {
                        title: "真密度仪",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/zhengmiduyi.jpg")
                    },
                    {
                        title: "振实密度仪",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/pingzhi/zhengshimiduyi.jpg")
                    },

                ]
            },
            honorAndAualification: {
                headlineTitle: "技术专利",
                headlineP: "TECHNICAL PATENTS",
                list: [
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/1.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/2.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/3.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/4.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/5.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/6.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/7.jpg") },
                    { picUrl: require("../../assets/img/businessScope/productionManufacturing/zhuanli/8.jpg") },
                ]
            },
            schoolEnterpriseCooperation: {
                headlineTitle: "校企合作",
                headlineP: "SCHOOL-ENTERPRISE COOPERATION",
                des: "<p>同时与辽宁石油化工大学、东北大学</p><p>等多所大专院校</p><p>建立 <span style='color:#0054A7;'>“ 产学研 ” 校企合作</span></p>",
                tip: "更多院校更新中..."
            },
        },
        AL: {
            factory: {
                headlineTitle: "铝制品加工厂",
                headlineP: "ALUMINIUM PRODUCT PROCESSING PLANT",
                des: "铝制品加工厂是大庆高新国际工贸集团的全资子公司，生产各类铝卷和铝板等产品的工厂，为广泛行业提供产品服务，包括航空航天，汽车，房屋和建筑，交通运输，包装和生活用品。",
                factoryBox: {
                    title: "ALUMINIUM PRODUCT PROCESSING PLANT",
                    smallTitle: "铝制品加工厂",
                    des: "可生产销售各类铝卷、铝箔、铝板，可广泛应用于汽车、建筑、航空航天、化工、计算机、食品加工、家具、厨具等多个领域，产品已出口至巴西、墨西哥、阿联酋、越南、泰国、菲律宾等30多个国家。"
                }
            },
            manufacturingStrength: {
                headlineTitle: "优质服务",
                headlineP: "MANUFACTURING STRENGTH",
                lists: [{
                        title: "产品定制",
                        des: "向我们展示样品或图纸，我们将为您带来完美的产品。",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service1.png")
                    },
                    {
                        title: "费用与服务",
                        des: "集生产和销售于一体，我们拥有轧制和深加工车间以及专业的外贸团队。您不仅可以享受制造商的价格还有专业的外贸服务。",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service2.png")
                    },
                    {
                        title: "响应速度",
                        des: "您的电子邮件、询价和问题会在2小时内回复。 短时间内完成各项工作，样品和批量订单都会高标准的准时交货。",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service3.png")
                    },
                    {
                        title: "产品质量",
                        des: "严格的质量控制体系和先进的检验设备。",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/service4.png")
                    },
                ]
            },
            mainProduct: {
                headlineTitle: "主营产品",
                headlineP: "MAIN PRODUCT",
                lists: [{
                        title: "铝板",
                        des: "<p>厚度范围：0.2-20毫米</p><p>宽度范围：50-2200毫米</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvban.png")
                    },
                    {
                        title: "铝卷",
                        des: "<p>厚度范围：0.2-5毫米0.2-5mm</p><p>宽度范围：50-1600毫米</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvjuan.png")
                    },
                    {
                        title: "铝圆片",
                        des: "<p>厚度范围：0.5-5毫米</p><p>宽度范围：150-1500毫米</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvyuanpian.png")
                    },
                    {
                        title: "铝箔",
                        des: "<p>厚度范围：0.01-0.2毫米</p><p>宽度范围：50-2200毫米</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvbo.png")
                    },
                    {
                        title: "铝棒",
                        des: "<p>厚度范围：1-3000毫米</p><p>宽度范围：50-2200毫米</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvbang.png")
                    },
                    {
                        title: "铝锭",
                        des: "<p>厚度范围：760*185*90毫米</p><p>重量：约为20-25千克</p>",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/lvding.png")
                    },
                ]
            },
            qualityAssurance: {
                headlineTitle: "品质保障",
                headlineP: "QUALITY ASSURANCE",
                lists: [{
                        title: "拉弯矫设备",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz1.png")
                    },
                    {
                        title: "热轧机轧辊",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz2.png")
                    },
                    {
                        title: "热轧机组",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz3.png")
                    },
                    {
                        title: "库房库存",
                        picUrl: require("../../assets/img/businessScope/productionManufacturing/al/pz4.png")
                    },

                ]
            },
        },

    },
    industryFinanceCollaboration: {
        banner: {
            bannerTitle: "产融协同",
            bannerP: "Industry Finance Collaboration",
        },
        globalLayout: {
            headlineTitle: "全球布局",
            headlineP: "LOREM IPSUM DOLOR SIT",
            des: `大庆高新国际工贸集团于2007年开始，陆续在韩国、日本、印尼、迪拜等多地设立办事处，经过多年的深耕发展，公司跨境业务现已覆盖六大领域：能源化工原料及其制品、机械装备及工业设备、新能源材料及其锂电池延伸产品、金属矿产、农化产品、二手车出口。`,
            map: require("../../assets/img/businessScope/industryFinanceCollaboration/map.png"),
        },
        generationMiningAndGenerationPin: {
            headlineTitle: "代采与代销",
            headlineP: "GENERATION MINING AND GENERATION PIN",
            enterpriseAdvantage: {
                title: "企业优势",
                titleEn: "ENTERPRISE ADVANTAGE",
                des: "<p>中方/跨境</p><p>进口（代采）</p><p>出口（代销）</p>",
                btn: "联系我们"
            },
            lists: [{
                    title: "海运",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/haiyun.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/haiyun.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/haiyun.png"),
                },
                {
                    title: "货代",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/huodai.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/huodai.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/huodai.png"),
                },
                {
                    title: "结算",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/jiesuan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/jiesuan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/jiesuan.png"),
                },
                {
                    title: "港口",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/gangkou.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/gangkou.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/gangkou.png"),
                },
                {
                    title: "班列",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/banlie.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/banlie.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/banlie.png"),
                },
                {
                    title: "海外仓",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/haiwaicang.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/haiwaicang.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/haiwaicang.png"),
                },
                {
                    title: "检验",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/jianyan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/jianyan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/jianyan.png"),
                },
                {
                    title: "报关",
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageIcon/baoguan.png"),
                    circlePic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantageCircle/baoguan.png"),
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/enterpriseAdvantage/baoguan.png"),
                },
            ]
        },
        protectionAndFactoring: {
            headlineTitle: "保障与保理",
            headlineP: "PROTECTION AND FACTORING",
            des1: `大庆高新国际工贸集团于2023年获评中国出口信用保险公司(以下简称“中国信保”)AAA级客户，为黑龙江省第一家获此殊荣的民营企业，同时也是黑龙江省第一家获批中国信保内贸信用保险的民营企业。`,
            des2: `公司提供全程一站式采购、运输、销售供应链服务，保障国际间货物流、信息资金流、票据流顺畅，保证按客户要求提供高性价比货物。对石油设备、工程机械、车辆配件、电子产品及矿石类等大宗商品采购销售业务拥有专业渠道，结合门到门运输服务可为客户提供一站式采购销售平台。`
        },
        industrialInvestment: {
            headlineTitle: "产业投资",
            headlineP: "INDUSTRIAL INVESTMENT",
            des: "公司将继续坚持以市场为导向，以客户为中心，以创新为动力，为投资者、合作伙伴和社会创造更大的价值。",
            lists: [{
                    title: "锂电业务",
                    des: "公司投资侧重围绕主营业务石油焦贸易和锂电池负极材料生产（锂电池负极材料制造、锂电池回收利用），企业上下游能源领域并购整合，以提高产业链的协同效应和竞争力，形成了一个完整的能源循环体系。",
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/lidian.png"),
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/lidian_icon.png"),
                },
                {
                    title: "氢能源业务",
                    des: "公司还注重探索新能源领域的投资机遇，与国内外知名的科研机构和高校合作，开展了氢能制取技术的研究和试验，取得了一系列的突破和创新。在未来几年内，公司计划收、并购孵化具有自主知识产权的氢能制取设备企业，为能源转型和低碳发展做出贡献。",
                    pic: require("../../assets/img/businessScope/industryFinanceCollaboration/qingnengyuan.png"),
                    icon: require("../../assets/img/businessScope/industryFinanceCollaboration/qingnengyuan_icon.png"),
                },
            ]

        }
    },
    exportOfServices: {
        banner: {
            bannerTitle: "劳务输出",
            bannerP: "Export of services",
        },
        headlineTitle: "劳务输出",
        headlineP: "EXPORT OF SERVICES",
        des1: `大庆高新国际工贸集团旨在为全球企业提供一站式人力资源服务，构建强有力的人力资源服务保障体系，
        打造高活力、高敏捷、可持续的人才供应链。`,
        enterpriseAdvantage: {
            title: "企业优势",
            titleEn: "ENTERPRISE ADVANTAGE",
            des: `依托过往20年所沉淀的实践经验，深度研究企业内外部的人力资源需求和供应分析，结合企业人力资源管理现状和战略需求，
            为企业的人力资源全体系、全结构进行设计与规划。与此同时，基于数字化时代的兴起，
            大庆高新的人力资源规划将重点投入研究数字化劳动力和信息化的服务升级，为各大用工企业提供深度的服务与支持。`
        },
        des2: `目前，公司已服务国内外企业20余家，涵盖人力资源规划、薪酬绩效设计、激励机制、组织规划、流程制度、岗位体系、
        人才培养等八大类精细化全方位一站式服务。建立了专业优质人才库，包含石油化工类、电气仪表类、机械类、半导体类、新能源锂电类、
        大宗贸易类、综合职能类、技工类、后勤保障类等十余类不同行业。`,
        lists: [{
                title: "20+",
                des: "服务国内外合作企业超20余家"
            },
            {
                title: "8+",
                des: "八大类精细化全方一站式服务"
            },
            {
                title: "15+",
                des: "涉及十余类不同行业"
            },
        ]

    },
    news: {
        banner: {
            bannerTitle: "新闻资讯",
            bannerP: "News Information",
        },
        latestNews: {
            headlineTitle: "最新资讯",
            headlineP: "LATEST NEWS",
        },
        mediaReport: {
            headlineTitle: "媒体报道",
            headlineP: "MEDIA REPORT",
        },
        enterprisePublicity: {
            headlineTitle: "企业宣传",
            headlineP: "ENTERPRISE PUBLICITY",
        },
        parameter: {
            read: "阅读全文"
        }
    },
    newsDetail: {
        home: "首页",
        lists: "新闻资讯",
        time: "时间：",
        edit: "编辑：大庆高新国际工贸集团",
        share: "分享至",
        pre: "上一篇：",
        next: "下一篇："
    },
    socialResponsibility: {
        banner: {
            bannerTitle: "社会责任",
            bannerP: "Social Responsibility",
        },
        environmentalProtection: {
            headlineTitle: "环境保护",
            headlineP: "ENVIRONMENTAL PROTECTION",
            des: {
                text1: `公司深入践行绿色发展理念，持续关注企业及供应链中的环境保护、可再生能源使用、节能减排、资源回收利用，倡导“绿色循环经济”，推进节能减排，以实际行动践行绿色承诺，助力实现“双碳”目标。`,
                text2: `公司旗下抚顺工厂按照地方政府15年内不淘汰规范进行规划，采用德国超低排放先进技术进行的环保设计，实现所有废料再利用，全程无工业废渣、废水、废弃物的排放。`
            }
        },
        scienceAndTechnologyInnovate: {
            headlineTitle: "科技创新",
            headlineP: "SCIENCE AND TECHNOLOGY INNOVATE",
            des: {
                text1: `大庆高新国际工贸集团在抚顺、哈尔滨等多地建立科研基地，加强科技人才队伍建设，聘请国际国内科研技术专家重点研究高纯石墨制作及应用新技术开发，冶炼新工艺等，以持续推动公司科技创新。`,
                text2: `在生产与加工方面，公司旗下工厂从原料入厂到出成品，生产全过程实现智能化、自动化、管道化输送和密闭式生产，员工不参与任何设备操作，全程只需进行巡视检查。工厂消防也实施热感应自动追踪灭火设计，从设备工艺本质上解决安全隐患问题。`
            }
        },
        socialGood: {
            headlineTitle: "社会公益",
            headlineP: "SOCIAL GOOD",
            des: {
                title: "向黑龙江省红十字捐款100万及物资",
                text1: `2022年9月，抗击新冠疫情进入关键时刻，大庆高新国际工贸集团主动承担起企业的社会责任，向黑龙江省大庆红十字会捐款100万，以实际行动支援大庆疫情防控工作。这笔捐款用于采购必要的防疫物资，提供给需要帮助的人，确保他们的健康安全。`,
                text2: `2023年8月，黑龙江省五常市持续遭受强降雨遭受严重洪涝灾害。灾情发生后，公司第一时间向五常市红十字会捐赠抗洪救灾款，为五常人民战胜洪灾、重建家园贡献一份力量。`
            },
            des2: {
                title: "向伊朗等多国大使馆共捐赠超百万防疫物资",
                text1: `万里同好，命运与共！2020年7月，鉴于国内外疫情防控工作处于艰难时期，大庆高新国际工贸集团及国内外各分公司向伊朗等多个国家的大使馆捐赠消毒液、口罩等多种防疫物资，携手各国友人齐心协力共同战胜疫情。`
            }

        }
    },
    talentDevelopment: {
        banner: {
            bannerTitle: "人才发展",
            bannerP: "Talent development",
        },
        growthAndDevelopment: {
            headlineTitle: "成长与发展",
            headlineP: "GROWTH AND DEVELOPMENT",
            des: `<p>我们秉持能上能下、能岗匹配、知人善用、用人所长的用人机制，给予有能力的员工充分展现自己的舞台。</p><p>“做一样，像一样，成一样”是大庆高新人的特质。</p><p>这里人际关系简单，有公平的晋升机制和广阔的发展空间。</p>`,
            boxRow: {
                title: "人才是第一生产力，大庆高新国际工贸集团始终坚持以人为本。",
                p: '维护员工各项合法权益，通过为员工创造广阔的发展平台，开展专业化培训'
            },
            boxRow2: {
                title: "关心关爱员工生活，提升员工归属感和价值感",
                p: '提升行业竞争力，从而达成企业、员工共同成长的目标'
            }
        },
        employeeCare: {
            headlineTitle: "员工关爱",
            headlineP: "EMPLOYEE CARE",
            des: '集团高度重视员工综合素质的培养以及专业技能的开发，建设学习型团队，使员工与企业一同成长，努力实现企业和社会、员工的共同发展。'
        },
        talentRecruitment: {
            headlineTitle: "人才招聘",
            headlineP: "TALENT RECRUITMENT",
            des: '在这个日新月异的时代，我们深知，人才是企业最宝贵的财富，因此我们诚挚地向每一位怀揣梦想、勇于挑战的你发出邀请。',
            part1: '社会招聘',
            part2: '兼职招聘',
            join: '/加入我们'
        },
    },
    talentRecruitment: {
        banner: {
            bannerTitle: "人才招聘",
            bannerP: "Talent Recruitment",
        },
        tabs: {
            society: '社会招聘',
            partTime: '兼职招聘',
            postName: '招聘岗位',
            userNum: '招聘人数',
            workArea: '工作地点',
            wages: '薪资待遇',
            createTime: '发布时间',
            btn: '投递简历',
            mainWork: '职位描述',
            baseDemand: '任职要求'
        },
        updataForm: {
            title: '上传简历',
            updataBtn: '上传',
            type: '格式',
            submitBtn: '提交'
        }
    },
    supervisionAndReporting: {
        banner: {
            bannerTitle: "监督举报",
            bannerP: "Supervision and reporting",
        },
        introduce: `为了加强廉政建设，杜绝违法违纪行为，保持员工队伍的清正廉洁，培养员工高尚的职业操守，
        保证员工履行职务的廉洁性，处理损害公司利益和形象的行为及员工因贪污收受商业贿赂渎职而损害履行职务廉洁性的
        行为，公司鼓励全体员工、合作单位及社会各界积极举报舞弊等违规违纪行为，并对举报人给予高额奖励，
        同时对举报人进行严格保护。`,
        reporting1: {
            headlineTitle: "举报形式",
            headlineP: "REPORTING FORM",
            title1: "一、举报范围",
            title2: "二、举报渠道",
            des1: `<p>公司鼓励所有知情人员就如下舞弊行为进行举报或提供有效证据:</p> 
            <p>1.员工收受贿赂 (如礼品、礼金、回扣、手续费、干股、旅游、高档娱乐活动等）或其他好处   (如借款借物等)、盗窃、
            侵占或挪用公司资产、欺诈、泄露公司秘密、滥用职权不当关联交易、利用职权谋取私利等舞整行为。</p>
            <p>2.供应商或外单位行贿、盗窃、侵占、欺诈、侵犯商业秘密等违法违规或违反廉洁协议的行为。</p>`,
            des2: `<p>举报电话: 17813617807</p><p>举报邮箱: gh_wang@gaoxincarbon.com</p>
            <p>微信公众号:大庆高新国际工贸集团</p><p>其他途径:来信来访或其他任何形式</p>`
        },
        reporting2: {
            headlineTitle: "举报奖励",
            headlineP: "REPORTING REWARDS",
            title1: `一、对于举报信息或提供的证据，相关信息能直接被司法机关采用且案件被定性为刑事案件的，按照如下标准给予奖励:`,
            title2: `二、对于举报或提供真实且能被直接采用的信息或证据的，并为公司挽回直接经济损失的 (以公司实际到账金额或财务部门认定的数额为准)，按照如下标准给予奖励:`,
            title3: `三、上述各项奖励经董事长批准后可以叠加使用。`,
            title4: `四、对于合作单位举报或提供直接有效证据的，同样适用于上述奖励条款。`,
            des1: `
            <p>1.涉及非国家工作人员受贿类的案件，给予不低于30000元奖励;</p>
            <p>2.涉及职务侵占、盗窃、挪用资金等其他类型刑事案件的，给予不低于10000元的奖励。</p>
            `,
            des2: `<p>1.挽回经济损失10万元 (含本数) 以下的，给予1000元奖励; </p>
            <p>2.挽回经济损失10万元至50万元（含本数）的，给予1000元至5000元奖励;</p>
            <p>3.挽回经济损失50万元至200万元 (含本数）的，给予5000元至20000元奖励;</p>
            <p>4.挽回经济损失200万元至800万元(含本数)的，给予20000元至80000元奖励;</p>
            <p>5.挽回经济损失800万元以上的，给予100000元奖励。</p>`,
            btn: '线上举报'
        },
        dialogForm: {
            title: '监督举报',
            email: '举报邮箱',
            reporterType: '举报类型',
            reporterItems: '举报事项',
            reportered: '被举报人',
            reporteredTip: '被举报人姓名',
            deptName: '所在单位及部门',
            reporter: '举报人',
            reporterTip: '举报人姓名',
            ifShow: '匿名',
            reporterMobile: '举报人联系方式',
            file: '上传举报材料',
            fileTip: '将文件拖到此处，或',
            fileBtn: '点击上传',
            remark: '问题描述',
            remarkTip: '请填写问题描述',
            btn: '提交',
            reporterItemsTip: '请至少选择一个举报事项',
            deptNameTip: '请填写所在单位及部门',
            reporterMobileTip: '请填写举报人联系方式',
            uploadTip: '上传文件不能超过'

        }
    },
    contact: {
        banner: {
            bannerTitle: "联系我们",
            bannerP: "Contact Us",
        },
        descLists: [{
                url: require("../../assets/img/contact/address.png"),
                title: '总部地址:',
                desc: '北京市朝阳区安慧里四区15号中国五矿大厦13层'
            },
            {
                url: require("../../assets/img/contact/phone.png"),
                title: '公司电话:',
                desc: '+86 10-84831159总机  &nbsp; &nbsp;  +86 10-84833454内贸  &nbsp;&nbsp;  +86 10-84832433外贸 <br/> 业务合作：+86 17813617961 &nbsp;&nbsp; 总裁办公室：+86 17813617885'
            },
            {
                url: require("../../assets/img/contact/email.png"),
                title: '邮箱:',
                desc: 'Gaoxin@gaoxincarbon.com'
            },
        ],
        wxName: '微信公众号',
        dyName: '抖音官方号',
        wdName: '微店'
    },
    year20: {
        // banner: {
        //     bannerTitle: "2020年",
        //     bannerP: "2020",
        // },
        vedio: {
            headling: '大庆高新20周年庆典隆重举行'
        },
        history: {
            headling: '发展历程'
        },
        news: {
            headling: '大庆高新20周年新闻报道'
        },
        employee: {
            headling: '大庆高新20周年功勋员工',
            des: '十年磨一剑，十五年铸辉煌，二十年创传奇。在公司二十年的发展历程中，有这样一群功勋员工，他们与公司一同历经风雨，用青春与梦想，坚守与奋斗，共同谱写了公司的辉煌篇章。来自全国各地的10年、15年、20年功勋员工齐聚一堂，接受集团的表彰。集团也为他们精心准备了一份特别的礼物—一枚沉甸甸的纯金功勋奖章，以此感谢他们的卓越贡献，功勋员工代表们也纷纷上台发表真挚而感人的讲话，讲述与公司成长的点点滴滴。',
            title15: '15年功勋员工',
            title10: '10年功勋员工',
            title20: '20年功勋员工'
        },
        bless: {
            headling: '大庆高新20周年来自「他们」的祝福'
        },
        activity: {
            headling: '大庆高新20周年主题活动'
        },
    }

}

export default cn;